import { Component, Inject, OnInit, } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PaymentPeriod, Site } from '@shared/models';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'fc-confirm-removal-dialog',
  templateUrl: './confirm-removal-dialog.component.html',
  styleUrls: ['./confirm-removal-dialog.component.scss'],
  standalone: false
})
export class ConfirmRemovalDialogComponent implements OnInit {
  removalForm: UntypedFormGroup;
  unPaidPaymentPeriods: PaymentPeriod[] = [];
  currentValuation: number;
  perPeriodRemoval: number;
  pendingNetErt: number = 0;
  currentBufferPercent: number = 0;
  perPeriodGross: number = 0;
  perPeriodBuffer: number = 0;

  constructor(
    readonly dialogRef: MatDialogRef<ConfirmRemovalDialogComponent>,
    readonly formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: {
      activeSite: Site,
      totalRemovalErt: number,
      currentPpt: number,
      removalValuation: number
    }
  ) {
    this.unPaidPaymentPeriods = data.activeSite.paymentPeriods.filter(pp => pp.paymentId == null)
    this.currentValuation = parseFloat(data.activeSite.valuation.split(',')[0]);
    // net = gross - deduction - acr - internal
    let pp = this.unPaidPaymentPeriods[0];
    if (pp.sequence == 0) {
      pp = this.unPaidPaymentPeriods[1]; // skip initial period
    }
    this.currentBufferPercent = Math.abs((pp.acrBufferErt + pp.internalBufferErt) / (pp.grossErt + pp.deductionErt));
    // acr and internal are just percentages of gross - deduction
  }

  ngOnInit() {
    this.removalForm = this.formBuilder.group({
      clawbackPeriods: [1, Validators.required],
    });
    this.updatePeriod();
  }

  submitRemoval(): void {
    this.dialogRef.close(this.removalForm.controls.clawbackPeriods.value);
  }

  updatePeriod() {
    this.perPeriodGross = (this.currentValuation - this.data.removalValuation) / 12 * this.data.activeSite.enrollmentGroup.payPeriodCadence;
    this.perPeriodRemoval = this.removalForm.controls.clawbackPeriods.value ? this.data.totalRemovalErt / this.removalForm.controls.clawbackPeriods.value : 0
    this.perPeriodBuffer = this.perPeriodGross * this.currentBufferPercent;
    // new gross - new buffer - removal deduction
    this.pendingNetErt = this.perPeriodGross - this.perPeriodRemoval - this.perPeriodBuffer;
  }

}
